module.exports = __webpack_public_path__ + "static/media/upgrade-hero-banner.72fd7ab0.png";